// import { useState, useRef, useEffect } from 'react'
// import { Camera } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import { Nav, Form, Button, Container } from 'react-bootstrap'
// import CoursesSection from '../Components/Profile Section/CourseSection'
// import TimelineSection from '../Components/Profile Section/TimelineSection'
// import Header from '../Components/Header'
// import StudentSdebar from './StudentSdebar'
// import ConnectionsSection from '../Components/Profile Section/ConnectionSection'
// import GroupsSection from '../Components/Profile Section/GroupsSection'
// import PhotosSection from '../Components/Profile Section/PhotosSection'
// import ForumsSection from '../Components/Profile Section/ForumSection'
// import EmailInvitesSection from '../Components/Profile Section/EmailInviteSection'
// import axios from 'axios'
// import { motion, AnimatePresence } from "framer-motion"

// const tabs = [
//   { name: 'Profile' },
//   { name: 'Courses' },
//   { name: 'Timeline' },
//   { name: 'Connections' },
//   { name: 'Groups', count: 1 },
//   // { name: 'Photos' },
//   // { name: 'Forums' },
//   { name: 'Email Invites' },
// ]

// export default function ProfilePage() {
//   const navigate = useNavigate()
//   const [activeTab, setActiveTab] = useState('Profile')
//   const [isEditing, setIsEditing] = useState(false)
//   const [profileData, setProfileData] = useState({
//     firstName: '',
//     lastName: '',
//     nickname: '',
//     profile_pic: '',
//     cover_photo: '',
//   })
//   const [bannerImage, setBannerImage] = useState(null)
//   const [profileImage, setProfileImage] = useState(null)
//   const [sidebarExpanded, setSidebarExpanded] = useState(false);
//   const bannerInputRef = useRef(null)
//   const profileInputRef = useRef(null)

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       const token = localStorage.getItem('jwttoken')
//       try {
//         const response = await axios.get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         const { first_name, last_name, nickname, profile_pic, cover_photo } =
//           response.data
//         setProfileData({
//           firstName: first_name,
//           lastName: last_name,
//           nickname,
//           profilePic: profile_pic,
//           cover_photo,
//         })
//         // setBannerImage(cover_photo); // Set cover photo dynamically
//         setBannerImage(`data:image/jpeg;base64,${cover_photo}`)
//         setProfileImage(profile_pic)
//       } catch (error) {
//         console.error('Error fetching user profile:', error)
//       }
//     }

//     fetchUserProfile()
//   }, [])

//   const handleImageUpload = (event, type) => {
//     const file = event.target.files?.[0]
//     if (file) {
//       const reader = new FileReader()
//       reader.onloadend = () => {
//         if (typeof reader.result === 'string') {
//           if (type === 'banner') {
//             setBannerImage(reader.result)
//           } else {
//             setProfileImage(reader.result)
//           }
//         }
//       }
//       reader.readAsDataURL(file)
//     }
//   }

//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setProfileData((prev) => ({
//       ...prev,
//       [name]: value,
//     }))
//   }

//   return (
//     <>
//       <Header />
//       <div className='d-flex' >
//       <div className="wrapper" style={{ display: "flex" }}>
//       <StudentSdebar onToggle={setSidebarExpanded} />

//       <motion.div
//         className="main-content p-lg-4 p-md-3 p-2"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//         style={{
//           marginTop: '60px', // Adjust this to match your Header height
//           marginLeft: sidebarExpanded ? '260px' : '90px',
//           transition: 'margin-left 0.25s ease-in-out',
//           width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 90px)',
//           // overflowY: 'auto',
//           height: 'calc(100vh - 60px)',
//         }}
//       >


//         {/* Main Content */}
//         <div className='min-vh-100 bg-light flex-grow-1 '>
//           {/* Banner and Profile Section */}
//           <div className='position-relative'>
//             <div
//               className='position-relative'
//               style={{
//                 height: '12rem',
//                 backgroundImage: bannerImage ? `url(${bannerImage})` : 'none',
//                 backgroundColor: bannerImage ? 'transparent' : '#6c757d', // Fallback color
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 backgroundRepeat: 'no-repeat', // Prevents tiling of the image
//                 overflow: 'hidden', // Ensures no overflow from the container
//                 borderRadius: '0.3rem', // Optional: Add rounded corners if required
//                 cursor: 'pointer',
//               }}
//               onClick={() => bannerInputRef.current?.click()}
//             >
//               <div className='position-absolute top-0 start-0 m-3'>
//                 <div
//                   className='rounded-circle bg-white p-2 d-flex align-items-center justify-content-center'
//                   style={{
//                     width: '2.5rem',
//                     height: '2.5rem',
//                   }}
//                 >
//                   <Camera
//                     className='text-secondary'
//                     style={{ width: '1.5rem', height: '1.5rem' }}
//                   />
//                 </div>
//               </div>
//               <input
//                 type='file'
//                 ref={bannerInputRef}
//                 className='d-none'
//                 accept='image/*'
//                 onChange={(e) => handleImageUpload(e, 'banner')}
//               />
//             </div>

//             <Container className='max-w-5xl px-4'>
//               <div className='position-relative' style={{ marginTop: '-6rem' }}>
//                 <div
//                   className='position-relative d-inline-block'
//                   onClick={() => profileInputRef.current?.click()}
//                   style={{
//                     width: '12rem',
//                     height: '12rem',
//                   }}
//                 >
//                   <div
//                     className='rounded-circle bg-light position-relative overflow-hidden'
//                     style={{
//                       width: '12rem',
//                       height: '12rem',
//                       border: '8px solid white',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         backgroundImage: profileImage
//                           ? `url(${profileImage}`
//                           : 'none',
//                         backgroundColor: profileImage
//                           ? 'transparent'
//                           : '#e9ecef',
//                         backgroundSize: 'cover',
//                         backgroundPosition: 'center',
//                         borderRadius: '50%',
//                       }}
//                     />
//                     {!profileImage && (
//                       <i
//                         className='bi bi-camera'
//                         style={{
//                           fontSize: '2rem',
//                           color: '#6c757d',
//                         }}
//                       />
//                     )}
//                     <div
//                       className='position-absolute d-flex flex-column justify-content-center align-items-center'
//                       style={{
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         background: 'rgba(0, 0, 0, 0.5)',
//                         borderRadius: '50%',
//                         opacity: 0,
//                         transition: 'opacity 0.3s',
//                         cursor: 'pointer',
//                         color: 'white',
//                       }}
//                       onMouseOver={(e) => (e.currentTarget.style.opacity = 1)}
//                       onMouseOut={(e) => (e.currentTarget.style.opacity = 0)}
//                     >
//                       <i
//                         className='bi bi-camera'
//                         style={{ fontSize: '1rem' }}
//                       />
//                       <span style={{ fontSize: '1rem', marginTop: '0.5rem' }}>
//                         Change Profile Photo
//                       </span>
//                     </div>
//                   </div>
//                   <span
//                     className='position-absolute rounded-circle bg-success'
//                     style={{
//                       width: '1rem',
//                       height: '1rem',
//                       border: '2px solid white',
//                       top: '1.5rem',
//                       right: '1.5rem',
//                     }}
//                   />
//                   <input
//                     type='file'
//                     ref={profileInputRef}
//                     className='d-none'
//                     accept='image/*'
//                     onChange={(e) => handleImageUpload(e, 'profile')}
//                   />
//                 </div>

//                 <div className='mt-4'>
//                   <h1 className='h3 fw-bold text-dark'>
//                     {profileData.firstName}{profileData.lastName}
//                   </h1>
//                   <p className='text-muted small'>
//                     @{profileData.nickname} • Joined May 2023 • Active now
//                   </p>
//                 </div>
//               </div>
//             </Container>
//           </div>

//           {/* Navigation Tabs
//           <div className="border-bottom">
//             <Container className="max-w-5xl px-4">
//               <Nav className="gap-4">
//                 {tabs.map((tab) => (
//                   <Nav.Item key={tab.name}>
//                     <Nav.Link
//                       onClick={() => setActiveTab(tab.name)}
//                       className={`border-bottom border-3 py-3 px-1 ${
//                         activeTab === tab.name
//                           ? "border-primary text-primary"
//                           : "border-transparent text-muted"
//                       }`}
//                     >
//                       {tab.name}
//                       {tab.count && (
//                         <span
//                           className={`ms-2 rounded-pill px-2 py-1 small ${
//                             activeTab === tab.name
//                               ? "bg-primary-subtle text-primary"
//                               : "bg-light text-dark"
//                           }`}
//                         >
//                           {tab.count}
//                         </span>
//                       )}
//                     </Nav.Link>
//                   </Nav.Item>
//                 ))}
//               </Nav>
//             </Container>
//           </div> */}

//           {/* Navigation Tabs */}
//           <div
//             style={{
//               overflowX: 'auto',
//               whiteSpace: 'nowrap',
//               backgroundColor: '#fff',
//               boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, 0.1)',
//               padding: '8px 0',
//               borderRadius: '10px',
//             }}
//           >
//             <Container className='max-w-5xl px-4'>
//               <Nav
//                 className='nav nav-pills justify-content-center'
//                 style={{ display: 'flex', gap: '10px', padding: '0 10px' }}
//               >
//                 {tabs.map((tab) => (
//                   <Nav.Item key={tab.name} className='nav-item'>
//                     <Nav.Link
//                       onClick={() => setActiveTab(tab.name)}
//                       className={`nav-link ${
//                         activeTab === tab.name ? 'active' : ''
//                       }`}
//                       style={{
//                         color: activeTab === tab.name ? 'white' : '#555',
//                         backgroundColor:
//                           activeTab === tab.name ? '#B8529E' : 'transparent',
//                         borderRadius: '20px',
//                         padding: '8px 12px',
//                         transition: '0.3s',
//                       }}
//                     >
//                       {tab.name}
//                       {tab.count && (
//                         <span
//                           className='ms-2 rounded-pill px-2 py-1 small'
//                           style={{
//                             backgroundColor:
//                               activeTab === tab.name ? '#E8B3D5' : '#f8f9fa',
//                             color: activeTab === tab.name ? '#B8529E' : '#555',
//                           }}
//                         >
//                           {tab.count}
//                         </span>
//                       )}
//                     </Nav.Link>
//                   </Nav.Item>
//                 ))}
//               </Nav>
//             </Container>
//           </div>

//           {/* Content Section */}
//           <Container className='max-w-5xl px-4 py-4'>
//             {activeTab === 'Timeline' && <TimelineSection />}
//             {activeTab === 'Profile' && (
//               <div className='card shadow-sm'>
//                 <div className='card-body'>
//                   <div className='d-flex justify-content-between align-items-center mb-4'>
//                     <h2 className='h5 fw-bold mb-0'>Details</h2>
//                     {/* <Button
//                       variant='link'
//                       className='text-primary p-0'
//                       onClick={() => navigate('/editprofile')}
//                     >
//                       Edit
//                     </Button> */}
//                   </div>

//                   <Form>
//                     <div className='mb-4'>
//                       <Form.Label className='text-muted small'>
//                         First Name
//                       </Form.Label>
//                       {isEditing ? (
//                         <Form.Control
//                           type='text'
//                           name='firstName'
//                           value={profileData.firstName}
//                           onChange={handleInputChange}
//                         />
//                       ) : (
//                         <p className='mb-0'>{profileData.firstName}</p>
//                       )}
//                     </div>

//                     <div className='mb-4'>
//                       <Form.Label className='text-muted small'>
//                         Last Name
//                       </Form.Label>
//                       {isEditing ? (
//                         <Form.Control
//                           type='text'
//                           name='lastName'
//                           value={profileData.lastName}
//                           onChange={handleInputChange}
//                         />
//                       ) : (
//                         <p className='mb-0'>{profileData.lastName}</p>
//                       )}
//                     </div>

//                     <div className='mb-4'>
//                       <Form.Label className='text-muted small'>
//                         Nickname
//                       </Form.Label>
//                       {isEditing ? (
//                         <Form.Control
//                           type='text'
//                           name='nickname'
//                           value={profileData.nickname}
//                           onChange={handleInputChange}
//                         />
//                       ) : (
//                         <p className='mb-0'>{profileData.nickname}</p>
//                       )}
//                     </div>
//                   </Form>
//                 </div>
//               </div>
//             )}
//             {activeTab === 'Courses' && <CoursesSection />}
//             {activeTab === 'Connections' && <ConnectionsSection />}
//             {activeTab === 'Groups' && <GroupsSection />}
//             {activeTab === 'Photos' && <PhotosSection />}
//             {activeTab === 'Forums' && <ForumsSection />}
//             {activeTab === 'Email Invites' && <EmailInvitesSection />}
//             {activeTab !== 'Profile' &&
//               activeTab !== 'Courses' &&
//               activeTab !== 'Timeline' &&
//               activeTab !== 'Connections' &&
//               activeTab !== 'Groups' &&
//               activeTab !== 'Photos' &&
//               activeTab !== 'Forums' &&
//               activeTab !== 'Email Invites' && (
//                 <div className='card shadow-sm'>
//                   <div className='card-body text-center text-muted'>
//                     {activeTab} content goes here
//                   </div>
//                 </div>
//               )}
//           </Container>
//         </div>
//         </motion.div>
//         </div>
//       </div>
//     </>
//   )
// }


import { useState, useRef, useEffect } from 'react'
import { Camera } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Nav, Form, Button, Container } from 'react-bootstrap'
import CoursesSection from '../Components/Profile Section/CourseSection'
import TimelineSection from '../Components/Profile Section/TimelineSection'
import Header from '../Components/Header'
import StudentSdebar from './StudentSdebar'
import GroupsSection from '../Components/Profile Section/GroupsSection'
import PhotosSection from '../Components/Profile Section/PhotosSection'
import ForumsSection from '../Components/Profile Section/ForumSection'
import EmailInvitesSection from '../Components/Profile Section/EmailInviteSection'
import axios from 'axios'
import { motion, AnimatePresence } from "framer-motion"

const tabs = [
  { name: 'Profile' },
  { name: 'Courses' },
  { name: 'Timeline' },

  { name: 'Groups', count: 1 },
  // { name: 'Email Invites' },
]

export default function ProfilePage() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('Profile')
  const [isEditing, setIsEditing] = useState(false)
  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    nickname: '',
    profile_pic: '',
    cover_photo: '',
  })
  const [bannerImage, setBannerImage] = useState(null)
  const [profileImage, setProfileImage] = useState(null)
  const [sidebarExpanded, setSidebarExpanded] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const bannerInputRef = useRef(null)
  const profileInputRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])






  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = localStorage.getItem('jwttoken')
      try {
        const response = await axios.get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        const { first_name, last_name, nickname, profile_pic, cover_photo, join_date } =
          response.data
        setProfileData({
          firstName: first_name,
          lastName: last_name,
          nickname,
          profilePic: profile_pic,
          cover_photo,
          join_date: formatJoinDate(join_date),
        })
        setBannerImage(`data:image/jpeg;base64,${cover_photo}`)
        setProfileImage(profile_pic)
      } catch (error) {
        console.error('Error fetching user profile:', error)
      }
    }

    fetchUserProfile()
  }, [])

  const formatJoinDate = (dateString) => {
    if (!dateString) return "";   // ⬅️ SAFETY CHECK

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return ""; // ⬅️ Invalid date check

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return `${String(date.getDate()).padStart(2, "0")} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const handleImageUpload = (event, type) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          if (type === 'banner') {
            setBannerImage(reader.result)
          } else {
            setProfileImage(reader.result)
          }
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <>
      <Header />
      <div className='d-flex'>
        <div className="wrapper" style={{ display: "flex", width: '100%' }}>
          <StudentSdebar onToggle={setSidebarExpanded} />

          <motion.div
            className="main-content p-lg-4 p-md-3 p-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{
              marginTop: '60px',
              marginLeft: sidebarExpanded ? '240px' : '60px',
              transition: 'margin-left 0.25s ease-in-out',
              width: sidebarExpanded ? 'calc(100% - 240px)' : 'calc(100% - 60px)',
              height: 'calc(100vh - 60px)',
              overflowY: 'auto',
            }}
          >
            {/* Main Content */}
            <div className='min-vh-100 bg-light flex-grow-1'>
              {/* Banner and Profile Section */}
              <div className='position-relative'>
                <div
                  className='position-relative'
                  style={{
                    height: isMobile ? '8rem' : '12rem',
                    backgroundImage: bannerImage ? `url(${bannerImage})` : 'none',
                    backgroundColor: bannerImage ? 'transparent' : '#6c757d',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    overflow: 'hidden',
                    borderRadius: '0.3rem',
                    cursor: 'pointer',
                  }}
                  onClick={() => bannerInputRef.current?.click()}
                >
                  <div className='position-absolute top-0 start-0 m-3'>
                    <div
                      className='rounded-circle bg-white p-2 d-flex align-items-center justify-content-center'
                      style={{
                        width: '2.5rem',
                        height: '2.5rem',
                      }}
                    >
                      <Camera
                        className='text-secondary'
                        style={{ width: '1.5rem', height: '1.5rem' }}
                      />
                    </div>
                  </div>
                  <input
                    type='file'
                    ref={bannerInputRef}
                    className='d-none'
                    accept='image/*'
                    onChange={(e) => handleImageUpload(e, 'banner')}
                  />
                </div>

                <Container className='px-4'>
                  <div className='position-relative' style={{ marginTop: isMobile ? '-4rem' : '-6rem' }}>
                    <div
                      className='position-relative d-inline-block'
                      onClick={() => profileInputRef.current?.click()}
                      style={{
                        width: isMobile ? '8rem' : '12rem',
                        height: isMobile ? '8rem' : '12rem',
                      }}
                    >
                      <div
                        className='rounded-circle bg-light position-relative overflow-hidden'
                        style={{
                          width: isMobile ? '8rem' : '12rem',
                          height: isMobile ? '8rem' : '12rem',
                          border: '8px solid white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            backgroundImage: profileImage
                              ? `url(${profileImage}`
                              : 'none',
                            backgroundColor: profileImage
                              ? 'transparent'
                              : '#e9ecef',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            borderRadius: '50%',
                          }}
                        />
                        {!profileImage && (
                          <i
                            className='bi bi-camera'
                            style={{
                              fontSize: isMobile ? '1.5rem' : '2rem',
                              color: '#6c757d',
                            }}
                          />
                        )}
                        <div
                          className='position-absolute d-flex flex-column justify-content-center align-items-center'
                          style={{
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0, 0, 0, 0.5)',
                            borderRadius: '50%',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            cursor: 'pointer',
                            color: 'white',
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.opacity = 1)}
                          onMouseOut={(e) => (e.currentTarget.style.opacity = 0)}
                        >
                          <i
                            className='bi bi-camera'
                            style={{ fontSize: isMobile ? '0.8rem' : '1rem' }}
                          />
                          <span style={{
                            fontSize: isMobile ? '0.7rem' : '1rem',
                            marginTop: '0.5rem',
                            textAlign: 'center',
                            padding: '0 5px'
                          }}>
                            Change Profile Photo
                          </span>
                        </div>
                      </div>
                      <span
                        className='position-absolute rounded-circle bg-success'
                        style={{
                          width: isMobile ? '0.8rem' : '1rem',
                          height: isMobile ? '0.8rem' : '1rem',
                          border: '2px solid white',
                          top: isMobile ? '1rem' : '1.5rem',
                          right: isMobile ? '1rem' : '1.5rem',
                        }}
                      />
                      <input
                        type='file'
                        ref={profileInputRef}
                        className='d-none'
                        accept='image/*'
                        onChange={(e) => handleImageUpload(e, 'profile')}
                      />
                    </div>

                    <div className='mt-3'>
                      <h1 className={isMobile ? 'h5 fw-bold text-dark' : 'h3 fw-bold text-dark'}>
                        {profileData.firstName} {profileData.lastName}
                      </h1>
                      <p className="text-muted small">
                        • Joined{" "}
                        {profileData.join_date ? (
                          profileData.join_date
                        ) : (
                          <span
                            style={{
                              display: "inline-block",
                              width: "80px",
                              height: "12px",
                              backgroundColor: "#e0e0e0",
                              borderRadius: "4px",
                            }}
                          />
                        )}
                      </p>

                    </div>
                  </div>
                </Container>
              </div>

              {/* Navigation Tabs */}
              <div
                style={{
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                  backgroundColor: '#fff',
                  boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, 0.1)',
                  padding: '8px 0',
                  borderRadius: '10px',
                }}
              >
                <Container className='px-4'>
                  <Nav
                    className='nav nav-pills'
                    style={{
                      display: 'flex',
                      gap: isMobile ? '5px' : '10px',
                      padding: '0 5px',
                      flexWrap: isMobile ? 'nowrap' : 'wrap',
                    }}
                  >
                    {tabs.map((tab) => (
                      <Nav.Item key={tab.name} className='nav-item'>
                        <Nav.Link
                          onClick={() => setActiveTab(tab.name)}
                          className={`nav-link ${activeTab === tab.name ? 'active' : ''}`}
                          style={{
                            color: activeTab === tab.name ? 'white' : '#555',
                            backgroundColor: activeTab === tab.name ? '#B8529E' : 'transparent',
                            borderRadius: '20px',
                            padding: isMobile ? '6px 10px' : '8px 12px',
                            transition: '0.3s',
                            fontSize: isMobile ? '0.8rem' : '1rem',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {tab.name}
                          {tab.count && (
                            <span
                              className='ms-2 rounded-pill px-2 py-1 small'
                              style={{
                                backgroundColor: activeTab === tab.name ? '#E8B3D5' : '#f8f9fa',
                                color: activeTab === tab.name ? '#B8529E' : '#555',
                                fontSize: isMobile ? '0.7rem' : '0.8rem',
                              }}
                            >
                              {tab.count}
                            </span>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Container>
              </div>

              {/* Content Section */}
              <Container className='px-4 py-4'>
                {activeTab === 'Timeline' && <TimelineSection />}
                {activeTab === 'Profile' && (
                  <div className='card shadow-sm'>
                    <div className='card-body'>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <h2 className={isMobile ? 'h6 fw-bold mb-0' : 'h5 fw-bold mb-0'}>Details</h2>
                      </div>

                      <Form>
                        <div className='mb-3'>
                          <Form.Label className='text-muted small'>
                            First Name
                          </Form.Label>
                          {isEditing ? (
                            <Form.Control
                              type='text'
                              name='firstName'
                              value={profileData.firstName}
                              onChange={handleInputChange}
                              size={isMobile ? 'sm' : undefined}
                            />
                          ) : (
                            <p className='mb-0'>{profileData.firstName}</p>
                          )}
                        </div>

                        <div className='mb-3'>
                          <Form.Label className='text-muted small'>
                            Last Name
                          </Form.Label>
                          {isEditing ? (
                            <Form.Control
                              type='text'
                              name='lastName'
                              value={profileData.lastName}
                              onChange={handleInputChange}
                              size={isMobile ? 'sm' : undefined}
                            />
                          ) : (
                            <p className='mb-0'>{profileData.lastName}</p>
                          )}
                        </div>

                        {/* <div className='mb-3'>
                          <Form.Label className='text-muted small'>
                            Nickname
                          </Form.Label>
                          {isEditing ? (
                            <Form.Control
                              type='text'
                              name='nickname'
                              value={profileData.nickname}
                              onChange={handleInputChange}
                              size={isMobile ? 'sm' : undefined}
                            />
                          ) : (
                            <p className='mb-0'>{profileData.nickname}</p>
                          )}
                        </div> */}
                      </Form>
                    </div>
                  </div>
                )}
                {activeTab === 'Courses' && <CoursesSection />}
                {activeTab === 'Groups' && <GroupsSection />}
                {activeTab === 'Photos' && <PhotosSection />}
                {activeTab === 'Forums' && <ForumsSection />}
                {/* {activeTab === 'Email Invites' && <EmailInvitesSection />} */}
                {activeTab !== 'Profile' &&
                  activeTab !== 'Courses' &&
                  activeTab !== 'Timeline' &&

                  activeTab !== 'Groups' &&
                  activeTab !== 'Photos' &&
                  activeTab !== 'Forums' &&
                  activeTab !== 'Email Invites' && (
                    <div className='card shadow-sm'>
                      <div className='card-body text-center text-muted'>
                        {activeTab} content goes here
                      </div>
                    </div>
                  )}
              </Container>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  )
}